// import { ethers } from 'ethers'
// import { SenderTokenABI,  } from 'config'

// const batchAirToken = (
//   YagongAddress,
//   signer,
//   tokenAddress,
//   tokens,
//   amounts,
//   decimals: number,
//   yagongPrice: number,
// ) => {
//   return new Promise(async (resolve, reject) => {
//     const contract = new ethers.Contract(YagongAddress, SenderTokenABI, signer)
//     const _amounts = []
//     amounts.forEach((amount) => {
//       const _amount = ethers.utils.parseUnits(amount, decimals)
//       _amounts.push(_amount.toString())
//     })
//     const price = ethers.utils.parseEther(yagongPrice.toString())
//     try {
//       const res = await contract.batchAirToken(tokenAddress, tokens, _amounts, { value: price })
//       signer.provider.once(res.hash, () => {
//         resolve(true)
//       })
//     } catch (error) {
//       reject(error)
//     }
//   })
// }
// export default batchAirToken

import {
  parseUnits,
  parseEther,
  type WalletClient,
  type PublicClient,
  type Address,
  type Hash
} from 'viem'
import { SenderTokenABI } from '@/config'

const batchAirToken = async (
  YagongAddress: Address,
  walletClient: WalletClient,
  publicClient: PublicClient,
  tokenAddress: string,
  tokens: string[],
  amounts: string[],
  decimals: number,
  yagongPrice: number,
): Promise<boolean> => {
  try {
    // 解析金额
    const _amounts = amounts.map((amount) =>
      parseUnits(amount, decimals)
    )
      console.log('_amounts::: ', _amounts);

    // 解析价格
    const price = parseEther(yagongPrice.toString())
    console.log('yagongPrice::: ', yagongPrice);

    // 调用合约
    const hash = await walletClient.writeContract({
      address: YagongAddress,
      abi: SenderTokenABI,
      functionName: 'batchAirToken',
      args: [tokenAddress, tokens, _amounts],
      value: price,
      chain: undefined,
      account: walletClient.account.address
    })

    await publicClient.waitForTransactionReceipt({ hash })

    return true
  } catch (error) {
    throw error
  }
}

export default batchAirToken